// extracted by mini-css-extract-plugin
module.exports = {"ejxs6xt":"ejxs6xt"};